// @ts-nocheck
// import React from "react";
import React from "@tuteria/shared-lib/src/react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";
import ReviewMediaUpload from "@tuteria/shared-lib/src/admin/ReviewMediaUpload";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
// import { displayToast } from "@tuteria/shared-lib/src/tutor-revamp/forms/SharedComponents";
// declare global {
//   interface Window {
//     $: any;
//   }
// }

export function unMountReviewComponent(node: any) {
  ReactDOM.unmountComponentAtNode(node);
}

const ComponentVerification = ({
  onClose,
  userInfo,
  mediaUrl,
  mediaType,
  onSubmit,
  profileUrl,
}) => {
  const [loading, setLoading] = React.useState({
    accept: false,
    reject: false,
  });
  // const displayToast = useToast()
  async function onApprove() {
    setLoading({ ...loading, accept: true });
    onSubmit("approve").catch((error) => {
      console.error(error);
      setLoading({ ...loading, accept: false });
      // displayToast({
      //   status: "error",
      //   title: "Error",
      //   duration: 4000,
      //   position: "top",
      //   description: "Action failed",
      // });
    });
  }

  async function onDeny() {
    setLoading({ ...loading, reject: true });
    onSubmit("deny").catch((error) => {
      console.error(error);
      setLoading({ ...loading, reject: false });
      // displayToast({
      //   status: "error",
      //   title: "Error",
      //   duration: 4000,
      //   position: "top",
      //   description: "Action failed",
      // });
    });
  }
  return (
    <ReviewMediaUpload
      isOpen
      onClose={onClose}
      mediaType={mediaType}
      mediaUrl={mediaUrl}
      userInfo={userInfo}
      loading={loading}
      onAccept={onApprove}
      onReject={onDeny}
      profileUrl={profileUrl}
    />
  );
};

type PayloadType = {
  data: any;
  type: "video" | "identity";
  email: string;
};
export function renderReviewComponent(
  payload: PayloadType,
  node: any,
  baseUrl = "",
  callback: (x: string) => void
) {
  let { data, type } = payload;
  const isIdentityUpload = type === "identity";
  const { actual_id, others, personal_info, user_id, identity } = data;

  function onSubmit(action) {
    let request = new Request(baseUrl, {
      method: "post",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id, type, action }),
    });
    return fetch(request)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        console.log(response);
        callback(action);
        onClose();
        return response.data;
      });
  }

  function onClose() {
    unMountReviewComponent(node);
  }
  ReactDOM.render(
    <ThemeProvider>
      <ComponentVerification
        onClose={onClose}
        mediaType={isIdentityUpload ? "image" : "video"}
        mediaUrl={isIdentityUpload ? actual_id.url : others?.videoSummary.url}
        userInfo={{
          name: `${personal_info.firstName} ${personal_info.lastName}`,
          dob: personal_info.dateOfBirth,
          gender: personal_info.gender,
        }}
        onSubmit={onSubmit}
        profileUrl={isIdentityUpload ? identity.profilePhoto : ""}
      />
    </ThemeProvider>,
    node
  );
}
